import { createSelector } from '@ngrx/store';
import { getRemoteConfigState } from '..';

export const getPreferredCountries = createSelector(
  getRemoteConfigState,
  (state) => state.preferred_countries ?? []
);
